/*
  BIZORA COD PRO — núcleo de los bloques COD de la ficha de producto.
  Estado compartido por sección (cantidad, variante, precios), formato de dinero y envío al carrito.
  Sin dependencias. Los demás bz-product-*.js lo usan a través de window.BZ.
*/
(function () {
  if (window.BZ) return;

  var stores = {};
  var EVT = 'bz:change';

  var BZ = (window.BZ = {});

  BZ.reducedMotion = function () {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };

  /* ---------- dinero ---------- */
  function num(cents, decimals, thousands, point) {
    var parts = (Math.round(cents) / 100).toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts[1] ? parts[0] + point + parts[1] : parts[0];
  }

  BZ.money = function (cents, format) {
    var fmt = format || '{{amount}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals':
          return num(cents, 0, ',', '.');
        case 'amount_with_comma_separator':
          return num(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return num(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator':
          return num(cents, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator':
          return num(cents, 0, ' ', '.');
        case 'amount_with_space_separator':
          return num(cents, 2, ' ', ',');
        case 'amount_with_period_and_space_separator':
          return num(cents, 2, ' ', '.');
        default:
          return num(cents, 2, ',', '.');
      }
    });
  };

  /* ---------- estado por sección ---------- */
  BZ.qtyInput = function (sid) {
    return (
      document.getElementById('Quantity-' + sid) ||
      document.querySelector('#MainProduct-' + sid + ' [data-bz-qty]') ||
      document.querySelector('[data-bz-qty]')
    );
  };

  BZ.store = function (sid) {
    if (!stores[sid]) {
      var input = BZ.qtyInput(sid);
      stores[sid] = {
        sectionId: sid,
        qty: input ? parseInt(input.value, 10) || 1 : 1,
        variant: null, // { id, title, price, compare, available, image }
        pricing: null, // { qty, total, strike } lo fija «Ofertas por cantidad»
      };
    }
    return stores[sid];
  };

  BZ.set = function (sid, patch) {
    var st = BZ.store(sid);
    Object.assign(st, patch);
    document.dispatchEvent(new CustomEvent(EVT, { detail: st }));
  };

  BZ.on = function (sid, fn) {
    var handler = function (e) {
      if (e.detail.sectionId === sid) fn(e.detail);
    };
    document.addEventListener(EVT, handler);
    return function () {
      document.removeEventListener(EVT, handler);
    };
  };

  // Total y tachado para la cantidad actual (en céntimos).
  BZ.totals = function (st) {
    var v = st.variant;
    if (st.pricing && st.pricing.qty === st.qty) return { total: st.pricing.total, strike: st.pricing.strike };
    if (!v) return { total: 0, strike: 0 };
    var strike = v.compare > v.price ? v.compare * st.qty : 0;
    return { total: v.price * st.qty, strike: strike };
  };

  // Cambia la cantidad del formulario (visible o oculta) y avisa a Dawn y a las apps COD.
  BZ.setQty = function (sid, qty) {
    var input = BZ.qtyInput(sid);
    if (input) {
      input.value = qty;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    BZ.set(sid, { qty: qty });
  };

  // La cantidad cambia desde fuera (botones +/- de Dawn, teclado, apps).
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.name !== 'quantity' || !t.form && !t.getAttribute('form')) return;
    var host = t.closest('product-info');
    var sid = host ? host.dataset.section : null;
    if (!sid) {
      var m = /^Quantity-(.+)$/.exec(t.id || '');
      sid = m ? m[1] : null;
    }
    if (!sid) return;
    var q = parseInt(t.value, 10) || 1;
    if (BZ.store(sid).qty !== q) BZ.set(sid, { qty: q });
  });

  // Cambio de variante de Dawn.
  function listenVariants() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, function (payload) {
      var d = payload && payload.data;
      if (!d) return;
      var v = d.variant;
      BZ.set(d.sectionId, {
        variant: v
          ? {
              id: v.id,
              title: v.title,
              price: v.price,
              compare: v.compare_at_price || 0,
              available: v.available,
              image: v.featured_image && v.featured_image.src,
            }
          : null,
        pricing: null,
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', listenVariants);
  else listenVariants();

  /* ---------- formulario y carrito ---------- */
  BZ.form = function (id) {
    return document.getElementById(id);
  };

  BZ.nativeSubmit = function (form) {
    return form && form.querySelector('[type="submit"]');
  };

  BZ.submitForm = function (form) {
    if (!form) return;
    var btn = BZ.nativeSubmit(form);
    if (typeof form.requestSubmit === 'function') {
      try {
        form.requestSubmit(btn || undefined);
        return;
      } catch (e) {
        /* sigue al plan B */
      }
    }
    if (btn) btn.click();
    else form.submit();
  };

  // Línea de carrito a partir del formulario de producto (id, cantidad, propiedades, plan de venta).
  BZ.formItem = function (form) {
    var fd = new FormData(form);
    var item = { id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity'), 10) || 1 };
    var props = {};
    fd.forEach(function (value, key) {
      var m = /^properties\[(.+)\]$/.exec(key);
      if (m && value !== '') props[m[1]] = value;
    });
    if (Object.keys(props).length) item.properties = props;
    if (fd.get('selling_plan')) item.selling_plan = fd.get('selling_plan');
    return item;
  };

  BZ.busy = function (form, flag) {
    var btn = BZ.nativeSubmit(form);
    if (!btn) return;
    btn.classList.toggle('loading', flag);
    if (flag) btn.setAttribute('aria-disabled', 'true');
    else btn.removeAttribute('aria-disabled');
    var spinner = form.parentElement && form.parentElement.querySelector('.loading__spinner');
    if (spinner) spinner.classList.toggle('hidden', !flag);
  };

  BZ.showError = function (form, message) {
    var host = form && form.closest('product-form');
    var wrap = host && host.querySelector('.product-form__error-message-wrapper');
    if (!wrap) return;
    var text = wrap.querySelector('.product-form__error-message');
    if (text) text.textContent = message || '';
    wrap.toggleAttribute('hidden', !message);
  };

  function cartUrl() {
    return (window.routes && window.routes.cart_add_url) || '/cart/add.js';
  }

  // Añade varias líneas y repinta el carrito/cajón de Dawn.
  BZ.addItems = function (items, opts) {
    opts = opts || {};
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var body = { items: items };
    if (cart && !opts.redirect) {
      body.sections = cart.getSectionsToRender().map(function (s) {
        return s.id;
      });
      body.sections_url = window.location.pathname;
    }
    return fetch(cartUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message || 'cart');
        if (opts.redirect) {
          window.location.href = opts.redirect;
          return res;
        }
        if (!cart) {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          return res;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bz-product', cartData: res });
        }
        cart.renderContents(res);
        return res;
      });
  };

  // «Comprar ahora»: añade la línea del formulario con su cantidad y va al pago.
  BZ.buyNow = function (form, onError) {
    if (!form) return;
    var item = BZ.formItem(form);
    if (!item.id) return;
    BZ.busy(form, true);
    return BZ.addItems([item], { redirect: '/checkout' }).catch(function (err) {
      BZ.busy(form, false);
      BZ.showError(form, err.message);
      if (onError) onError(err);
    });
  };
})();
